// Downloads Layout Component
// Unified layout for both root and admin pages - same structure, different content via children

import { DownloadsControls } from './DownloadsControls';
import './DownloadsLayout.css';

export function DownloadsLayout({ admin = false, user, navigate, onBackToDownloads, onCreateDownloadClick, onManageTagsClick, urlQuery, urlSort, urlTags, searchParams, setSearchParams, children }) {
  return (
    <div className="downloads-layout">
      {/* Controls Row - Above header - Only show for admins */}
      {user?.role === 'admin' && (
        <div className="downloads-controls-row">
        {admin && onBackToDownloads ? (
          <button
            className="downloads-admin-btn downloads-back-btn"
            onClick={onBackToDownloads}
            title="Back to Downloads"
          >
            <i className="fa-solid fa-arrow-left"></i>
            Back to Downloads
          </button>
        ) : !admin && user?.role === 'admin' ? (
          <button
            className="downloads-admin-btn"
            onClick={() => navigate('/downloads/admin')}
            title="Manage Downloads (Admin)"
          >
            <i className="fa-solid fa-cog"></i>
            Admin
          </button>
        ) : null}
        {admin && onCreateDownloadClick && (
          <button
            className="downloads-admin-btn downloads-create-btn"
            onClick={onCreateDownloadClick}
            title="Create Download"
          >
            <i className="fa-solid fa-plus"></i>
            Create Download
          </button>
        )}
        {admin && onManageTagsClick && (
          <button
            className="downloads-admin-btn downloads-manage-tags-btn"
            onClick={onManageTagsClick}
            title="Manage Tags"
          >
            <i className="fa-solid fa-tags"></i>
            Manage Tags
          </button>
        )}
        </div>
      )}

      {/* Main content container with max width */}
      <div className="downloads-container">
        {/* Header with title and subtitle */}
        <div className="downloads-header">
          <h1 className="downloads-title">
            {admin ? 'Downloads Admin' : 'Downloads'}
          </h1>
          <p className="downloads-subtitle">
            {admin
              ? 'Manage downloads, categories, and access settings'
              : 'Access free tools, resources, and member-exclusive content'}
          </p>
        </div>

        {/* Search, sort, and tags controls */}
        <DownloadsControls
          urlQuery={urlQuery}
          urlSort={urlSort}
          urlTags={urlTags}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />

        {/* Main content area - same for both, content passed as children */}
        <div className="downloads-main-content">
          {children}
        </div>
      </div>
    </div>
  );
}